import { useModel } from '@umijs/max';
import { MutableRefObject } from 'react';
import { isIn3D } from '@/utils';
import { isInNewClouddesign } from 'utils/sunvegaAPI';
import { getValueFromSearchParams } from '@/utils';

const useExitMinDetail = (closePlaceholderExpand = true) => {
  const {
    setDetailId,
    setDetailItem,
    setIsHoverExpand,
    setInDetail,
    setInMinDetail,
    closeExpandWidthTimer,
  }: {
    setDetailId: (id: string, flag: boolean) => void;
    setDetailItem: (item: any) => void;
    setIsHoverExpand: (expand: boolean) => void;
    setInDetail: (inDetail: boolean) => void;
    setInMinDetail: (inMinDetail: boolean) => void;
    setCardDetailInfo: (info: any) => void;
    closeExpandWidthTimer: MutableRefObject<any>;
  } = useModel('detail');
  const { setIframePlaceholderExpand, iframePlaceholderExpandRef } =
    useModel('common');

  const exitMinDetail = () => {
    const isLatestOverlay = getValueFromSearchParams('latest') === '1';
    if (!iframePlaceholderExpandRef.current && !isLatestOverlay) return;
    if (!isInNewClouddesign || !isIn3D) return;
    const moreFilterRoot = document.getElementById('moreFilterRoot');
    setDetailId('', false);
    setDetailItem(null);
    setIsHoverExpand(false);
    if (
      closePlaceholderExpand &&
      !moreFilterRoot &&
      iframePlaceholderExpandRef.current
    ) {
      closeExpandWidthTimer.current = setTimeout(() => {
        console.log('closePlaceholderExpand');
        setIframePlaceholderExpand(false);
      }, 100);
    }
    // setTimeout(() => {
    //   setCardDetailInfo(null)
    // }, 100)
    setInDetail(false);
    setInMinDetail(false);
  };

  return exitMinDetail;
};

export default useExitMinDetail;
